import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Container, Overlay } from './Styles';

const Thumb = ({ index, item }) => (
  <Container className="animate" delay={index * 0.1}>
    <img alt={item.title} src={`${process.env.PUBLIC_URL}/${item.image_url_s}`} />
    <Link to={`/work/${item.id}`}>
      <Overlay>
        <h3>{item.title}</h3>
        <hr />
        <h3>{item.sub_title}</h3>
      </Overlay>
    </Link>
  </Container>
);

Thumb.propTypes = {
  index: PropTypes.number.isRequired,
  item: PropTypes.shape({
    title: PropTypes.string.isRequired
  })
};

export default Thumb;



// WEBPACK FOOTER //
// ./src/components/Thumb/index.js